// The app passes icons as Iconify class names ("i-lucide-plus"); the Polaris kit draws Carbon. This table is the
// translation, read by Icon.vue (and so by every Button). Names not here stay Iconify on purpose: channel and brand
// logos, file types, the woot's own status and priority marks, the filter operators (=, ≠, <, >, ∈) and the icons a user
// picks as content (emoji-icon-picker). Named imports keep the bundle to the icons used.
import {
  Activity16,
  Add16,
  AddAlt16,
  AddComment16,
  Alarm16,
  AlarmAdd16,
  AlarmSubtract16,
  Api16,
  ArrowDownLeft16,
  ArrowRight16,
  ArrowUp16,
  ArrowUpRight16,
  ArrowsVertical16,
  At16,
  Attachment16,
  Book16,
  Bot16,
  Building16,
  Bullhorn16,
  Cafe16,
  Calendar16,
  Categories16,
  Chat16,
  ChatBot16,
  Checkmark16,
  CheckmarkOutline16,
  ChevronDown16,
  ChevronLeft16,
  ChevronRight16,
  ChevronSort16,
  ChevronUp16,
  CircleDash16,
  Close16,
  CloseOutline16,
  CloudDownload16,
  Code16,
  ColorPalette16,
  Contrast16,
  Copy16,
  DataBase16,
  Document16,
  DocumentMultiple_0116,
  Download16,
  Draggable16,
  Earth16,
  Edit16,
  Email16,
  EmailNew16,
  Erase16,
  Eyedropper16,
  FaceAdd16,
  FaceDissatisfied16,
  FaceSatisfied16,
  FaceWink16,
  Filter16,
  Fire16,
  Flash16,
  Flow16,
  Folder16,
  FolderMoveTo16,
  Hashtag16,
  Heading16,
  Headphones16,
  Help16,
  Idea16,
  Image16,
  Industry16,
  Information16,
  Keyboard16,
  Launch16,
  Layers16,
  Link16,
  List16,
  ListBulleted16,
  ListNumbered16,
  Location16,
  LocationFilled16,
  Locked16,
  Logout16,
  MagicWand16,
  MagicWandFilled16,
  Maximize16,
  Menu16,
  Merge16,
  Microphone16,
  MicrophoneOff16,
  Minimize16,
  Misuse16,
  Mobile16,
  Moon16,
  Music16,
  Notebook16,
  Notification16,
  NotificationOff16,
  OverflowMenuVertical16,
  PageFirst16,
  PageLast16,
  Password16,
  Paste16,
  Pause16,
  PauseFilled16,
  Pen16,
  Phone16,
  PhoneFilled16,
  PhoneIncoming16,
  PhoneOff16,
  PhoneOutgoing16,
  PhoneVoice16,
  Play16,
  PlayFilledAlt16,
  PlayOutline16,
  Plug16,
  Portfolio16,
  Power16,
  Quotes16,
  RadioButton16,
  Redo16,
  Renew16,
  Reply16,
  Report16,
  Reset16,
  Restart16,
  Rotate16,
  Save16,
  Scales16,
  Screen16,
  Search16,
  SearchAdvanced16,
  Security16,
  Send16,
  Settings16,
  SettingsAdjust16,
  Share16,
  SidePanelClose16,
  SidePanelOpen16,
  SortAscending16,
  SortDescending16,
  Split16,
  Stamp16,
  Star16,
  StarFilled16,
  Stop16,
  Subtract16,
  SubtractAlt16,
  Sun16,
  Table16,
  Tablet16,
  Tag16,
  TagNone16,
  TextAlignJustify16,
  TextBold16,
  TextItalic16,
  TextStrikethrough16,
  Time16,
  Tools16,
  Translate16,
  TrashCan16,
  Undo16,
  Unlink16,
  Unlocked16,
  Upgrade16,
  Upload16,
  User16,
  UserAdmin16,
  UserAvatar16,
  UserAvatarFilled16,
  UserFollow16,
  UserMultiple16,
  UserProfile16,
  Video16,
  VideoFilled16,
  View16,
  ViewOff16,
  VolumeDown16,
  VolumeMute16,
  VolumeUp16,
  Warning16,
  WarningAlt16,
  ZoomIn16,
  ZoomOut16,
} from '@carbon/icons-vue';

export const CARBON_ICONS = {
  'i-lucide-plus': Add16,
  'i-lucide-plus-circle': AddAlt16,
  'i-lucide-minus': Subtract16,
  'i-lucide-circle-minus': SubtractAlt16,
  'i-lucide-x': Close16,
  'i-ph-x': Close16,
  'i-ph-x-bold': Close16,
  'i-woot-x': Close16,
  'i-lucide-x-circle': CloseOutline16,
  'i-lucide-circle-x': CloseOutline16,
  'i-lucide-check': Checkmark16,
  'i-lucide-check-check': CheckmarkOutline16,
  'i-lucide-check-circle': CheckmarkOutline16,
  'i-lucide-circle-check': CheckmarkOutline16,
  'i-lucide-circle-check-big': CheckmarkOutline16,
  'i-lucide-chevron-down': ChevronDown16,
  'i-lucide-chevron-up': ChevronUp16,
  'i-lucide-chevron-left': ChevronLeft16,
  'i-lucide-chevron-right': ChevronRight16,
  'i-ph-caret-right': ChevronRight16,
  'i-ph-caret-right-bold': ChevronRight16,
  'i-ph-caret-left': ChevronLeft16,
  'i-ph-caret-line-right-bold': PageLast16,
  'i-lucide-chevrons-right': PageLast16,
  'i-lucide-chevrons-left': PageFirst16,
  'i-lucide-chevrons-up-down': ChevronSort16,
  'i-lucide-trash': TrashCan16,
  'i-lucide-trash-2': TrashCan16,
  'i-woot-bin': TrashCan16,
  'i-ph-trash': TrashCan16,
  'i-lucide-info': Information16,
  'i-lucide-search': Search16,
  'i-lucide-search-x': SearchAdvanced16,
  'i-lucide-download': Download16,
  'i-ph-download-simple': Download16,
  'i-lucide-cloud-download': CloudDownload16,
  'i-lucide-upload': Upload16,
  'i-woot-edit-pen': Edit16,
  'i-lucide-pencil': Edit16,
  'i-lucide-pencil-line': Edit16,
  'i-lucide-pen': Pen16,
  'i-lucide-pen-line': Pen16,
  'i-ph-pencil-simple': Edit16,
  'i-lucide-user-pen': UserProfile16,
  'i-lucide-notebook-pen': Notebook16,
  'i-lucide-lock-keyhole': Locked16,
  'i-lucide-lock': Locked16,
  'i-lucide-lock-keyhole-open': Unlocked16,
  'i-lucide-external-link': Launch16,
  'i-lucide-arrow-up-right': ArrowUpRight16,
  'i-lucide-arrow-right': ArrowRight16,
  'i-lucide-arrow-up': ArrowUp16,
  'i-ph-arrow-up': ArrowUp16,
  'i-lucide-arrow-down-left': ArrowDownLeft16,
  'i-lucide-arrow-right-to-line': PageLast16,
  'i-lucide-arrow-left-to-line': PageFirst16,
  'i-lucide-arrow-down-to-dot': Download16,
  'i-lucide-arrow-down-up': ArrowsVertical16,
  'i-lucide-arrow-up-down': ArrowsVertical16,
  'i-lucide-ellipsis-vertical': OverflowMenuVertical16,
  'i-lucide-more-vertical': OverflowMenuVertical16,
  'i-lucide-eye': View16,
  'i-lucide-eye-off': ViewOff16,
  'i-lucide-refresh-cw': Renew16,
  'i-lucide-refresh-ccw': Renew16,
  'i-lucide-rotate-ccw': Reset16,
  'i-lucide-rotate-cw': Rotate16,
  'i-lucide-undo-2': Undo16,
  'i-lucide-redo': Redo16,
  'i-lucide-bot': Bot16,
  'i-lucide-bot-message-square': ChatBot16,
  'i-woot-captain': Bot16,
  'i-lucide-inbox': Email16,
  'i-lucide-mail': Email16,
  'i-woot-mail': Email16,
  'i-lucide-mail-plus': EmailNew16,
  'i-lucide-globe': Earth16,
  'i-woot-website': Earth16,
  'i-ri-global-fill': Earth16,
  'i-lucide-copy': Copy16,
  'i-woot-clone': Copy16,
  'i-lucide-clipboard': Paste16,
  'i-lucide-users-round': UserMultiple16,
  'i-lucide-users': UserMultiple16,
  'i-lucide-user': User16,
  'i-lucide-user-round': User16,
  'i-ph-user-bold': User16,
  'i-lucide-user-round-check': UserFollow16,
  'i-ph-user-gear': UserAdmin16,
  'i-ph-user-circle-plus': UserFollow16,
  'i-teenyicons-user-circle-solid': UserAvatarFilled16,
  'i-lucide-contact': UserProfile16,
  'i-lucide-triangle-alert': WarningAlt16,
  'i-lucide-alert-triangle': WarningAlt16,
  'i-lucide-alert-circle': Warning16,
  'i-lucide-circle-alert': Warning16,
  'i-lucide-link': Link16,
  'i-lucide-link-2': Link16,
  'i-ph-link-simple': Link16,
  'i-lucide-unlink': Unlink16,
  'i-lucide-clock': Time16,
  'i-lucide-clock-1': Time16,
  'i-lucide-clock-2': Time16,
  'i-lucide-clock-3': Time16,
  'i-lucide-clock-4': Time16,
  'i-lucide-clock-5': Time16,
  'i-lucide-clock-6': Time16,
  'i-lucide-clock-7': Time16,
  'i-lucide-clock-8': Time16,
  'i-lucide-clock-9': Time16,
  'i-lucide-clock-10': Time16,
  'i-lucide-clock-11': Time16,
  'i-lucide-clock-12': Time16,
  'i-lucide-alarm-clock': Alarm16,
  'i-lucide-alarm-clock-plus': AlarmAdd16,
  'i-lucide-alarm-clock-minus': AlarmSubtract16,
  'i-lucide-alarm-clock-check': Alarm16,
  'i-lucide-alarm-clock-off': Alarm16,
  'i-lucide-sparkles': MagicWand16,
  'i-ph-sparkle-fill': MagicWandFilled16,
  'i-fluent-pen-sparkle-24-regular': MagicWand16,
  'i-fluent-chat-sparkle-16-regular': ChatBot16,
  'i-fluent-circle-sparkle-24-regular': MagicWand16,
  'i-fluent-flow-sparkle-24-regular': Flow16,
  'i-fluent-sound-wave-circle-sparkle-24-regular': Microphone16,
  'i-fluent-text-bullet-list-square-sparkle-32-regular': ListBulleted16,
  'i-lucide-smile-plus': FaceAdd16,
  'i-lucide-smile': FaceSatisfied16,
  'i-ph-smiley-sticker': FaceSatisfied16,
  'i-lucide-message-circle': Chat16,
  'i-ph-chat-circle-dots': Chat16,
  'i-ph-chat-circle-text-bold': Chat16,
  'i-lucide-message-square-plus': AddComment16,
  'i-lucide-message-square-off': Chat16,
  'i-woot-quick-reply': Reply16,
  'i-lucide-zap': Flash16,
  'i-lucide-monitor': Screen16,
  'i-lucide-menu': Menu16,
  'i-lucide-image': Image16,
  'i-lucide-hash': Hashtag16,
  'i-woot-hash': Hashtag16,
  'i-lucide-file-text': Document16,
  'i-lucide-file': Document16,
  'i-lucide-files': DocumentMultiple_0116,
  'i-ph-files-light': DocumentMultiple_0116,
  'i-teenyicons-text-document-solid': Document16,
  'i-ph-article-ny-times': Document16,
  'i-lucide-scroll-text': Report16,
  'i-woot-settings': Settings16,
  'i-lucide-settings': Settings16,
  'i-lucide-sliders-vertical': SettingsAdjust16,
  'i-lucide-wrench': Tools16,
  'i-lucide-play': Play16,
  'i-ph-play': Play16,
  'i-teenyicons-play-small-solid': PlayFilledAlt16,
  'i-lucide-circle-play': PlayOutline16,
  'i-ph-pause': Pause16,
  'i-teenyicons-pause-small-solid': PauseFilled16,
  'i-ph-stop': Stop16,
  'i-lucide-list': List16,
  'i-lucide-list-ordered': ListNumbered16,
  'i-lucide-list-filter': Filter16,
  'i-lucide-filter': Filter16,
  'i-lucide-align-justify': TextAlignJustify16,
  'i-lucide-life-buoy': Help16,
  'i-lucide-languages': Translate16,
  'i-lucide-key-round': Password16,
  'i-lucide-key': Password16,
  'i-lucide-heart-crack': FaceDissatisfied16,
  'i-lucide-circle-off': Misuse16,
  'i-lucide-circle-fading-arrow-up': Upgrade16,
  'i-lucide-calendar': Calendar16,
  'i-lucide-calendar-range': Calendar16,
  'i-ph-calendar-dot': Calendar16,
  'i-ph-calendar-minus-bold': Calendar16,
  'i-lucide-building-2': Building16,
  'i-ph-building-light': Building16,
  'i-lucide-factory': Industry16,
  'i-lucide-briefcase-business': Portfolio16,
  'i-woot-voice': Phone16,
  'i-lucide-phone': Phone16,
  'i-ri-phone-fill': PhoneFilled16,
  'i-ph-phone-bold': Phone16,
  'i-ph-phone-call': PhoneVoice16,
  'i-ph-phone-call-bold': PhoneVoice16,
  'i-ph-phone-incoming': PhoneIncoming16,
  'i-ph-phone-incoming-bold': PhoneIncoming16,
  'i-ph-phone-outgoing': PhoneOutgoing16,
  'i-ph-phone-outgoing-bold': PhoneOutgoing16,
  'i-ph-phone-x': PhoneOff16,
  'i-ph-phone-x-bold': PhoneOff16,
  'i-woot-sms': Chat16,
  'i-lucide-volume-2': VolumeUp16,
  'i-lucide-volume-1': VolumeDown16,
  'i-lucide-volume-off': VolumeMute16,
  'i-lucide-audio-lines': Microphone16,
  'i-lucide-headphones': Headphones16,
  'i-lucide-music': Music16,
  'i-ph-microphone': Microphone16,
  'i-ph-microphone-bold': Microphone16,
  'i-ph-microphone-slash': MicrophoneOff16,
  'i-ph-microphone-slash-bold': MicrophoneOff16,
  'i-lucide-video': Video16,
  'i-ph-video-camera': Video16,
  'i-ph-video-camera-fill': VideoFilled16,
  'i-lucide-share-2': Share16,
  'i-lucide-share': Share16,
  'i-lucide-shapes': Categories16,
  'i-lucide-send': Send16,
  'i-lucide-scale': Scales16,
  'i-lucide-save': Save16,
  'i-lucide-panel-right-open': SidePanelOpen16,
  'i-lucide-panel-right-close': SidePanelClose16,
  'i-lucide-maximize-2': Maximize16,
  'i-lucide-maximize': Maximize16,
  'i-lucide-minimize': Minimize16,
  'i-lucide-expand': Maximize16,
  'i-lucide-keyboard': Keyboard16,
  'i-lucide-grip-vertical': Draggable16,
  'i-woot-drag-indicator': Draggable16,
  'i-lucide-circle-dot-dashed': CircleDash16,
  'i-lucide-circle-dashed': CircleDash16,
  'i-lucide-circle': RadioButton16,
  'i-lucide-bell': Notification16,
  'i-lucide-bell-minus': NotificationOff16,
  'i-lucide-archive-restore': Restart16,
  'i-lucide-activity': Activity16,
  'i-ph-activity': Activity16,
  'i-lucide-zoom-out': ZoomOut16,
  'i-lucide-zoom-in': ZoomIn16,
  'i-lucide-tag': Tag16,
  'i-woot-tag-remove': TagNone16,
  'i-lucide-tablet': Tablet16,
  'i-lucide-smartphone': Mobile16,
  'i-lucide-table': Table16,
  'i-lucide-swatch-book': ColorPalette16,
  'i-lucide-palette': ColorPalette16,
  'i-lucide-pipette': Eyedropper16,
  'i-lucide-sun': Sun16,
  'i-lucide-moon': Moon16,
  'i-lucide-strikethrough': TextStrikethrough16,
  'i-lucide-bold': TextBold16,
  'i-lucide-italic': TextItalic16,
  'i-lucide-heading-1': Heading16,
  'i-lucide-heading-2': Heading16,
  'i-lucide-heading-3': Heading16,
  'i-lucide-code': Code16,
  'i-ph-quotes': Quotes16,
  'i-lucide-star': Star16,
  'i-ri-star-line': Star16,
  'i-ri-star-fill': StarFilled16,
  'i-lucide-stamp': Stamp16,
  'i-lucide-signature': Pen16,
  'i-ph-signature': Pen16,
  'i-lucide-shield-check': Security16,
  'i-lucide-shield': Security16,
  'i-lucide-power': Power16,
  'i-lucide-plug': Plug16,
  'i-lucide-megaphone': Bullhorn16,
  'i-lucide-map-pin': Location16,
  'i-ph-navigation-arrow-fill': LocationFilled16,
  'i-lucide-log-out': Logout16,
  'i-lucide-lightbulb': Idea16,
  'i-lucide-layers': Layers16,
  'i-lucide-folder-input': FolderMoveTo16,
  'i-lucide-folder': Folder16,
  'i-lucide-flame': Fire16,
  'i-lucide-eraser': Erase16,
  'i-lucide-database': DataBase16,
  'i-lucide-book': Book16,
  'i-lucide-at-sign': At16,
  'i-lucide-ampersands': Hashtag16,
  'i-woot-logic-or': Split16,
  'i-lucide-castle': Building16,
  'i-lucide-glass-water': Cafe16,
  'i-ph-paperclip': Attachment16,
  'i-ph-arrows-merge': Merge16,
  'i-woot-sort-descending': SortDescending16,
  'i-woot-sort-ascending': SortAscending16,
  'i-woot-empty-assignee': UserAvatar16,
  'i-woot-onboarding-greeting': FaceWink16,
  'i-ri-contrast-2-line': Contrast16,
  'i-ri-contrast-2-fill': Contrast16,
  'i-woot-api': Api16,
};
